module.exports = require("./guz.d.ts");